import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { ProjetoSituacaoService } from '../services/projeto-situacao.service';

@Injectable({
  providedIn: 'root',
})
export class ProjetoSituacaoResolver implements Resolve<boolean> {
  constructor(private service: ProjetoSituacaoService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}
